import { contactInfo } from '../../data/constants'
import { useLanguage } from '../../contexts/LanguageContext'
import styles from './Footer.module.css'

const Footer = () => {
  const { t } = useLanguage()
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault()
    const element = document.getElementById(sectionId)
    if (element) {
      const targetPosition = element.offsetTop - 80
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      })
    }
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerContent}>
          <div className={`${styles.footerSection} ${styles.footerAbout}`}>
            <div className={styles.footerLogo}>
              <img src="/logo.png" alt="3K Digitale" className={styles.footerLogoImg} />
            </div>
            <p className={styles.footerDescription}>
              {t('footer.description')}
            </p>
          </div>
          
          <div className={`${styles.footerSection} ${styles.footerLinks}`}>
            <h3 className={styles.footerTitle}>{t('footer.quickLinks')}</h3>
            <ul className={styles.footerMenu}>
              <li><a href="#home" onClick={(e) => scrollToSection(e, 'home')}>{t('nav.home')}</a></li>
              <li><a href="#packages-preview" onClick={(e) => scrollToSection(e, 'packages-preview')}>{t('nav.packages')}</a></li>
              <li><a href="#portfolio" onClick={(e) => scrollToSection(e, 'portfolio')}>{t('nav.portfolio')}</a></li>
            </ul>
          </div>
          
          <div className={`${styles.footerSection} ${styles.footerServices}`}>
            <h3 className={styles.footerTitle}>{t('footer.services')}</h3>
            <ul className={styles.footerMenu}>
              <li><a href="#packages-preview" onClick={(e) => scrollToSection(e, 'packages-preview')}>{t('footer.service1')}</a></li>
              <li><a href="#packages-preview" onClick={(e) => scrollToSection(e, 'packages-preview')}>{t('footer.service2')}</a></li>
              <li><a href="#packages-preview" onClick={(e) => scrollToSection(e, 'packages-preview')}>{t('footer.service3')}</a></li>
            </ul>
          </div>
          
          <div className={`${styles.footerSection} ${styles.footerContact}`}>
            <h3 className={styles.footerTitle}>{t('footer.contact')}</h3>
            <div className={styles.footerContactItem}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              <span>{contactInfo.email}</span>
            </div>
            <div className={styles.footerContactItem}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
              <span>{contactInfo.phone}</span>
            </div>
            <div className={styles.footerContactItem}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span>{contactInfo.location}</span>
            </div>
          </div>
        </div>
        
        <div className={styles.footerBottom}>
          <p>&copy; 2024 3K Digitale. {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
